import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Adopt from "@/pages/Adopt";
import Stories from "@/pages/Stories";
import GetInvolved from "@/pages/GetInvolved";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Donate from "@/pages/Donate";
import Favorites from "@/pages/Favorites";
import Sponsor from "@/pages/Sponsor";
import QRFlyer from "@/pages/QRFlyer";
import { AuthProvider } from "@/context/AuthContext";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/adopt" element={<Adopt />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
          {/* Standalone print-friendly route (no navbar/footer/chat) */}
          <Route path="/qr-flyer" element={<QRFlyer />} />
          <Route path="/qr-flyer/:campaign" element={<QRFlyer />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
